import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  display: inline-block;
  vertical-align: middle;
  > .tooltip-bubble {
    width: max-content;
    max-width: 400px;
    display: inline-block;
    padding: 8px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    opacity: 0;
    visibility: hidden;
    background-color:  ${(props) => props.theme.primary.dark};;
    transition: opacity 0.4s;
    position: absolute;
    bottom: calc(100% + 8px);
    left: 50%;
    transform: translate(-50%);
    color: white;
    z-index: 2000;
    white-space: normal;
    word-break: break-word;
    text-align: left;
    pointer-events: none;

    &::before {
      content: "";
      border-style: solid;
      border-color: ${(props) => props.theme.primary.dark} transparent transparent transparent;
      border-width: 6px 6px 0 6px;
      top: 100%;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  &.tight > .tooltip-bubble {
    bottom: calc(100% - 12px);
  }
  &&:hover > .tooltip-bubble, &:focus-within > .tooltip-bubble {
    opacity: 1;
    visibility: visible;
  }
`;

export const Bubble = styled.div`
  position: fixed;
  transform: translate(-50%, calc(-100% - 8px));
  width: max-content;
  max-width: 400px;
  display: inline-block;
  padding: 8px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  opacity: 1;
  visibility: visible;
  background-color:  ${(props) => props.theme.primary.dark};
  color: white;
  z-index: 10000;
  white-space: normal;
  word-break: break-word;
  text-align: left;
  pointer-events: none;
  transition: opacity 140ms ease-out, transform 140ms ease-out;

  &::before {
    content: "";
    border-style: solid;
    border-color: ${(props) => props.theme.primary.dark} transparent transparent transparent;
    border-width: 6px 6px 0 6px;
    top: 100%;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }

  &.tight {
    transform: translate(-50%, calc(-100% + 12px));
  }
`;
